import { render, staticRenderFns } from "./CalabozoFilters.vue?vue&type=template&id=462e1eb8"
import script from "./CalabozoFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./CalabozoFilters.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalabozoFilters.vue?vue&type=style&index=0&id=462e1eb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports